import { render, staticRenderFns } from "./font-icon.vue?vue&type=template&id=471d5dfc"
import script from "./font-icon.vue?vue&type=script&lang=js"
export * from "./font-icon.vue?vue&type=script&lang=js"
import style0 from "./font-icon.vue?vue&type=style&index=0&id=471d5dfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports